import React from "react";


import {
    Row, Col
} from "react-bootstrap";

import {
    useDropzone
} from 'react-dropzone';


import {
    ButtonComponent, InputComponent
} from "@Components/Forms";


import IconArrowLeftSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_left-sm-brown.svg";
import IconArrowRightSmBrown from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-arrow_right-sm-brown.svg";
import IconArrowDropzoneMdYellow from "./@Icons/icon-arrow_dropzone-md-yellow.svg";


import "./index.scss";
import {UseQyvoUser} from "@Store/@Hooks";
import {SvgIconComponent} from "@Components/Elements";
import {DefaultLoaderComponent, DefaultPopupComponent} from "@Elements";
import IconCheckedRoundSmGreen from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-checked_round-sm-green.svg";
import IconErrorRoundSmRed from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps/@Icons/icon-error_round-sm-red.svg";
import {UserSubmitRequestDataInterface} from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest";


interface UserDashboardSubmitRequestStep2ComponentProps {
    userSubmitRequestStepSetter: (step: number) => void;
    userSubmitRequestData: UserSubmitRequestDataInterface;
    userSubmitRequestDataSetter: (userSubmitRequestData: UserSubmitRequestDataInterface) => void;
}


export const UserDashboardSubmitRequestStep2Component:React.FC<UserDashboardSubmitRequestStep2ComponentProps> = ({
    userSubmitRequestStepSetter,
    userSubmitRequestData, userSubmitRequestDataSetter
}) => {


    const QyvoUser = UseQyvoUser();


    const {
        acceptedFiles, getRootProps, getInputProps
    } = useDropzone({
        accept: {
            // 'image/jpeg': [],
            // 'image/png': [],
            'application/pdf': []
        }
    });

    const files = acceptedFiles.map(file => (
        <li key={file.path}>
            <SvgIconComponent iconSource={IconCheckedRoundSmGreen} />
            <span>{file.name}</span>
            {/*<span>{file.path} ({(file.size / 1024 / 1024).toFixed(2)}MB)</span>*/}
        </li>
    ));


    // function storeFileInLocalStorage(file:File) {
    //     const fileReader = new FileReader();
    //     fileReader.onload = function(base64) {
    //         localStorage["file"] = base64;
    //     }
    //     fileReader.readAsDataURL(file);
    // }


    const [verifyFilesInProgressStatus, setVerifyFilesInProgressStatus] = React.useState<boolean>(false);
    const [verifyFilesMessageType, setVerifyFilesMessageType] = React.useState('');
    const [verifyFilesMessage, setVerifyFilesMessage] = React.useState('');

    const verifyAttachedFilesHandler = () => {



        // if (!files.length) {
        //     setVerifyFilesMessageType('error');
        //     setVerifyFilesMessage('You need to attach at least 1 file');
        //     return;
        // }
        //
        // setVerifyFilesInProgressStatus(true);
        //
        // setTimeout(() => {
        //     setVerifyFilesMessageType('success');
        //     setVerifyFilesMessage('Files are ok');
        //     setVerifyFilesInProgressStatus(false);
        // }, 3000);

    };


    const nextStepRequestHandler = () => {

        if (!files.length) {
            setVerifyFilesMessageType('error');
            setVerifyFilesMessage('You need to attach at least 1 file');
            return;
        }

        const filesList = acceptedFiles.map((file) => {
            return {
                userDocumentName: file.name,
                userDocumentSize: file.size
            };
        });

        userSubmitRequestData.attachedDocumentsStep.documentsList = filesList;
        userSubmitRequestDataSetter({ ...userSubmitRequestData });

        setVerifyFilesInProgressStatus(true);

        setTimeout(() => {
            setVerifyFilesInProgressStatus(false);
            userSubmitRequestStepSetter(3);
        }, 3000);

    };


    return (
        <Col xs={12} className={'user-dashboard-submit-request-step'}>
            <Row className={'user-dashboard-submit-request-step__step-content'}>

                {verifyFilesInProgressStatus &&
                <DefaultLoaderComponent
                    defaultLoaderText={'Processing...'}
                />
                }

                <Col xs={12} className={'user-dashboard-submit-request-step__step-header'}>
                    <span className={'user-dashboard-submit-request-step__step-header__main-header'}>Documents - choosing a method</span>
                </Col>

                <Col xs={12} lg={6} className={'user-dashboard-submit-request-step__step-section step-2-attach-files-section chosen-request-option'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Upload documents</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-content step-2-attach-files-section__section-content'}>
                            <p>
                                Upload your documents so we can verify your information and begin processing your claim.
                            </p>
                            <p>
                                You can upload:<br/>
                                - e-ticket / booking confirmation<br/>
                                – boarding pass<br/>
                                – receipts (if needed for certain claims)<br/>
                            </p>

                        </Col>

                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form step-2-attach-files-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                <Col xs={12}
                                     {...getRootProps({className: 'dropzone-field-component'})}
                                >
                                    <input {...getInputProps()} />
                                    <SvgIconComponent iconSource={IconArrowDropzoneMdYellow}
                                                      className={'dropzone-field-component__field-icon'}/>
                                    <span className={'dropzone-field-component__field-information'}>Drag & drop files to upload</span>
                                    <ButtonComponent
                                        type={'flat'} size={'l'} bordered={true}
                                        text={'Browse files'}
                                    />
                                    {verifyFilesMessage &&
                                    <aside className={`dropzone-field-component__field-message ${verifyFilesMessageType}-field-message`}>
                                        <SvgIconComponent iconSource={verifyFilesMessageType === 'success' ? IconCheckedRoundSmGreen : IconErrorRoundSmRed} className={'dropzone-field-component__field-message__message-icon'} />
                                        <span className={'dropzone-field-component__field-message__message-icon'}>{verifyFilesMessage}</span>
                                    </aside>
                                    }
                                    {!files.length &&
	                                    <aside className={'dropzone-field-component__field-legend'}>
		                                    <span>Accepted file types: pdf (up to 25MB)</span>
	                                    </aside>
                                    }
                                    {files.length > 0 &&
                                    <aside className={'dropzone-field-component__field-files'}>
                                        <span className={'dropzone-field-component__field-files__files-label'}>Uploaded documents:</span>
                                        <ul className={'dropzone-field-component__field-files__files-list'}>{files}</ul>
                                    </aside>
                                    }
                                </Col>

                                {/*<Col xs={12}*/}
                                {/*     className={'user-dashboard-submit-request-step__step-section__section-legend step-2-attach-files-section__section-legend'}>*/}

                                {/*</Col>*/}

                                {/*<Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-button'}>*/}
                                {/*    <ButtonComponent*/}
                                {/*        type={'secondary'} size={'l'}*/}
                                {/*        text={'Verify'}*/}
                                {/*        callback={verifyAttachedFilesHandler}*/}
                                {/*    />*/}
                                {/*</Col>*/}

                            </Row>
                        </Col>

                    </Row>
                </Col>

                <Col xs={12} lg={6} className={'user-dashboard-submit-request-step__step-section step-2-verify-email-section'}>
                    <Row className={'user-dashboard-submit-request-step__step-section__section-container step-2-verify-email-section__section-content'}>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-header'}>
                            <span>Connect e-mail</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-content step-2-verify-email-section__section-description'}>
                            <span>Connect your e-mail so Qyvo can securely detect refund opportunities that apply to you.</span>
                        </Col>
                        <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form'}>
                            <Row className={'user-dashboard-submit-request-step__step-section__section-form__form-content'}>
                                <InputComponent
                                    value={QyvoUser?.qyvoUserEmail || ''} setValue={() => undefined}
                                    label={'Your Email'} disabled={true}
                                />
                                <Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-form__form-button verify-email-button'}>
                                    <ButtonComponent
                                        size={'l'} type={'flat'} bordered={true}
                                        text={'Verify'} buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>
                        {/*<Col xs={12} className={'user-dashboard-submit-request-step__step-section__section-legend'}>*/}
                        {/*    <span>Qyvo only sends messages if required to process your refund.</span>*/}
                        {/*</Col>*/}
                    </Row>
                </Col>

                <Col className={'user-dashboard-submit-request-step__step-buttons'}>
                    <Row className={'user-dashboard-submit-request-step__step-buttons__buttons-content'}>
                        <ButtonComponent
                            size={'l'} type={'flat'}
                            text={'Previous step'} iconLeft={IconArrowLeftSmBrown}
                            callback={() => userSubmitRequestStepSetter(1)}
                        />
                        <ButtonComponent
                            size={'l'}
                            text={'Next Step'} iconRight={IconArrowRightSmBrown}
                            callback={() => nextStepRequestHandler()}
                            buttonDisabled={!files.length}
                        />
                    </Row>
                </Col>
            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestStep2Component;
